import React from 'react';
import ActivePeriodFields from './ActivePeriodFields';
import EligibilityConditionsShared from './EligibilityConditionsShared';

const EligibilityConditionsBau = ({ formData, updateField, errorStartDate, errorEndDate, errorStartDatePast, errorDateOrder, showValidation = false }) => {
  return (
    <div className='eligibility-conditions-view'>
      <ActivePeriodFields formData={formData} updateField={updateField} errorStartDate={errorStartDate} errorEndDate={errorEndDate} errorStartDatePast={errorStartDatePast} errorDateOrder={errorDateOrder} />
      <EligibilityConditionsShared formData={formData} updateField={updateField} showValidation={showValidation} />
    </div>
  );
};

export default EligibilityConditionsBau;
